import CecAccountRoute from './CecAccountRoute'


const routes = [new CecAccountRoute()]

export default routes
